<template>
  <svg
    width="96"
    height="64"
    viewBox="0 0 96 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.9854 29.1815H29.9854V37.0974H32.9854V29.1815Z"
      fill="url(#paint0_radial_13_431)"
    />
    <path
      d="M32.9854 29.1815H29.9854V37.0974H32.9854V29.1815Z"
      fill="url(#paint1_radial_13_431)"
    />
    <path
      d="M65.9854 29.1815H62.9854V37.0974H65.9854V29.1815Z"
      fill="url(#paint2_radial_13_431)"
    />
    <path
      d="M65.9854 29.1815H62.9854V37.0974H65.9854V29.1815Z"
      fill="url(#paint3_radial_13_431)"
    />
    <path
      d="M72.0453 30.03H23.9553C22.3353 30.03 20.9854 28.71 20.9854 27.06V11.97C20.9854 10.35 22.3053 9 23.9553 9H72.0453C73.6653 9 75.0154 10.32 75.0154 11.97V27.06C74.9854 28.71 73.6653 30.03 72.0453 30.03Z"
      fill="url(#paint4_linear_13_431)"
    />
    <path
      d="M72.0453 30.03H23.9553C22.3353 30.03 20.9854 28.71 20.9854 27.06V11.97C20.9854 10.35 22.3053 9 23.9553 9H72.0453C73.6653 9 75.0154 10.32 75.0154 11.97V27.06C74.9854 28.71 73.6653 30.03 72.0453 30.03Z"
      fill="url(#paint5_linear_13_431)"
    />
    <path
      d="M72.0453 30.03H23.9553C22.3353 30.03 20.9854 28.71 20.9854 27.06V11.97C20.9854 10.35 22.3053 9 23.9553 9H72.0453C73.6653 9 75.0154 10.32 75.0154 11.97V27.06C74.9854 28.71 73.6653 30.03 72.0453 30.03Z"
      fill="url(#paint6_linear_13_431)"
    />
    <path
      d="M72.0453 30.03H23.9553C22.3353 30.03 20.9854 28.71 20.9854 27.06V11.97C20.9854 10.35 22.3053 9 23.9553 9H72.0453C73.6653 9 75.0154 10.32 75.0154 11.97V27.06C74.9854 28.71 73.6653 30.03 72.0453 30.03Z"
      fill="url(#paint7_radial_13_431)"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint8_linear_13_431)"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint9_radial_13_431)"
      fill-opacity="0.8"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint10_radial_13_431)"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint11_linear_13_431)"
      fill-opacity="0.8"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint12_radial_13_431)"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint13_radial_13_431)"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint14_radial_13_431)"
    />
    <path
      d="M37.9948 25.4598C37.9948 24.4098 37.4248 24.0198 36.3748 24.0198H32.2048L34.6348 21.5298C35.5948 20.5998 36.2548 19.7298 36.6748 18.8898C37.0648 18.0798 37.2748 17.2398 37.2748 16.3398C37.2748 14.9298 36.8248 13.8798 35.9248 13.1298C35.0248 12.3798 33.7048 12.0198 32.0248 12.0198C31.3348 12.0198 30.6148 12.1098 29.9248 12.2598C29.2348 12.4098 28.5748 12.6798 27.9148 13.0098C27.4099 13.2622 26.8942 13.8769 27.0148 14.4798C27.0748 14.7798 27.1948 15.0498 27.3748 15.2898C27.7348 15.7698 28.4248 15.9798 29.1448 15.6198C29.5648 15.3798 29.9548 15.2298 30.3448 15.1398C30.7348 15.0498 31.0948 14.9898 31.4248 14.9898C32.7748 14.9898 33.4948 15.7098 33.4948 16.7598C33.4948 17.1798 33.3748 17.5998 33.1348 18.0198C32.8948 18.4398 32.5048 18.9498 31.9648 19.5198L28.2448 23.4798C27.9448 23.7798 27.7348 24.0798 27.5548 24.3798C27.3748 24.6798 27.3448 24.9198 27.3448 25.3098C27.3448 25.8798 27.4948 26.2998 27.7648 26.5698C28.0348 26.8698 28.4848 26.9898 29.0848 26.9898H36.4048C37.6262 26.9898 37.9948 26.3398 37.9948 25.4598Z"
      fill="url(#paint15_radial_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint16_linear_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint17_linear_13_431)"
      fill-opacity="0.8"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint18_linear_13_431)"
      fill-opacity="0.9"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint19_linear_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint20_linear_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint21_radial_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint22_radial_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint23_radial_13_431)"
    />
    <path
      d="M51.0146 22.59C50.9546 23.4 50.2646 24 49.4546 24H47.9546V25.47C47.9546 26.28 47.3546 26.97 46.5446 27.03C45.6746 27.09 44.9546 26.4 44.9546 25.53V24H40.4246C40.1546 24 39.9146 23.91 39.6746 23.79C39.6446 23.76 39.6146 23.79 39.5846 23.76C39.5546 23.73 39.5246 23.7 39.4946 23.67C39.4046 23.61 39.3446 23.55 39.2846 23.46C39.2246 23.37 39.1646 23.31 39.1346 23.22C39.1046 23.13 39.0446 23.07 39.0446 22.95C39.0146 22.86 38.9846 22.74 38.9846 22.65C38.9846 22.59 38.9546 22.56 38.9546 22.5C38.9546 22.44 38.9846 22.41 38.9846 22.38C38.9846 22.29 39.0146 22.17 39.0446 22.08C39.0746 21.99 39.1046 21.9 39.1646 21.81C39.1946 21.78 39.1946 21.72 39.2246 21.69L45.2546 12.69C45.2846 12.66 45.3146 12.63 45.3446 12.6C45.4046 12.51 45.4646 12.45 45.5546 12.39C45.6446 12.33 45.7046 12.27 45.7946 12.24C45.8846 12.18 45.9746 12.15 46.0646 12.12C46.1546 12.09 46.2446 12.06 46.3646 12.06C46.4246 12.06 46.4546 12.03 46.5146 12.03C46.5746 12.03 46.6046 12.06 46.6646 12.06C46.7546 12.06 46.8446 12.09 46.9346 12.12C47.0246 12.15 47.1146 12.18 47.2046 12.24C47.2346 12.27 47.2946 12.27 47.3246 12.3C47.3546 12.33 47.3846 12.36 47.4146 12.39C47.5046 12.45 47.5646 12.51 47.6246 12.6C47.6846 12.69 47.7446 12.75 47.7746 12.84C47.8046 12.93 47.8646 12.99 47.8646 13.11C47.8946 13.2 47.9246 13.32 47.9246 13.41C47.9246 13.47 47.9546 13.5 47.9546 13.56V21.06H49.4846C50.3846 21 51.0746 21.72 51.0146 22.59ZM44.9846 21V18.45L43.2746 21H44.9846Z"
      fill="url(#paint24_radial_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint25_linear_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint26_linear_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint27_linear_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint28_linear_13_431)"
      fill-opacity="0.4"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint29_linear_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint30_radial_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint31_radial_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint32_radial_13_431)"
    />
    <path
      d="M68.9854 13.5V25.56C68.9854 26.37 68.3253 27.03 67.5153 27.03H67.4553C66.6453 27.03 65.9854 26.37 65.9854 25.56V21.06H59.9854V25.56C59.9854 26.37 59.3253 27.03 58.5153 27.03H58.4553C57.6453 27.03 56.9854 26.37 56.9854 25.56V13.5C56.9854 12.69 57.6453 12.03 58.4553 12.03H58.5153C59.3253 12.03 59.9854 12.69 59.9854 13.5V18.03H65.9854V13.5C65.9854 12.69 66.6453 12.03 67.4553 12.03H67.5153C68.3253 12.03 68.9854 12.69 68.9854 13.5Z"
      fill="url(#paint33_radial_13_431)"
    />
    <path
      d="M86.9853 45.3604H8.98535V84.0301H86.9853V45.3604Z"
      fill="url(#paint34_linear_13_431)"
    />
    <path
      d="M86.9853 45.3604H8.98535V84.0301H86.9853V45.3604Z"
      fill="url(#paint35_linear_13_431)"
    />
    <path
      d="M86.9853 45.3604H8.98535V84.0301H86.9853V45.3604Z"
      fill="url(#paint36_radial_13_431)"
    />
    <path
      d="M86.9853 45.3604H8.98535V84.0301H86.9853V45.3604Z"
      fill="url(#paint37_linear_13_431)"
    />
    <path
      d="M86.9853 45.3604H8.98535V84.0301H86.9853V45.3604Z"
      fill="url(#paint38_radial_13_431)"
      fill-opacity="0.8"
    />
    <path
      d="M86.9853 45.3604H8.98535V84.0301H86.9853V45.3604Z"
      fill="url(#paint39_linear_13_431)"
    />
    <path
      d="M41.9854 84.03H14.9854V55.8C14.9854 54.81 15.7654 54.03 16.7554 54.03H40.2154C41.2054 54.03 41.9854 54.81 41.9854 55.8V84.03Z"
      fill="url(#paint40_linear_13_431)"
    />
    <path
      d="M41.9854 84.03H14.9854V55.8C14.9854 54.81 15.7654 54.03 16.7554 54.03H40.2154C41.2054 54.03 41.9854 54.81 41.9854 55.8V84.03Z"
      fill="url(#paint41_linear_13_431)"
      fill-opacity="0.6"
    />
    <path
      d="M41.9854 84.03H14.9854V55.8C14.9854 54.81 15.7654 54.03 16.7554 54.03H40.2154C41.2054 54.03 41.9854 54.81 41.9854 55.8V84.03Z"
      fill="url(#paint42_linear_13_431)"
      fill-opacity="0.6"
    />
    <path
      d="M41.9854 84.03H14.9854V55.8C14.9854 54.81 15.7654 54.03 16.7554 54.03H40.2154C41.2054 54.03 41.9854 54.81 41.9854 55.8V84.03Z"
      fill="url(#paint43_linear_13_431)"
    />
    <path
      d="M41.9854 84.03H14.9854V55.8C14.9854 54.81 15.7654 54.03 16.7554 54.03H40.2154C41.2054 54.03 41.9854 54.81 41.9854 55.8V84.03Z"
      fill="url(#paint44_linear_13_431)"
    />
    <path
      d="M41.9854 84.03H14.9854V55.8C14.9854 54.81 15.7654 54.03 16.7554 54.03H40.2154C41.2054 54.03 41.9854 54.81 41.9854 55.8V84.03Z"
      fill="url(#paint45_radial_13_431)"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="#5EE6FF"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="url(#paint46_linear_13_431)"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="url(#paint47_linear_13_431)"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="url(#paint48_linear_13_431)"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="url(#paint49_linear_13_431)"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="url(#paint50_linear_13_431)"
    />
    <path
      d="M76.5454 72.03H52.4553C51.6453 72.03 50.9854 71.37 50.9854 70.56V61.47C50.9854 60.66 51.6453 60 52.4553 60H76.5454C77.3554 60 78.0154 60.66 78.0154 61.47V70.56C77.9854 71.37 77.3254 72.03 76.5454 72.03Z"
      fill="url(#paint51_linear_13_431)"
    />
    <path
      d="M87.7054 48.03H8.29534C7.03534 48.03 5.98535 47.01 5.98535 45.72V38.31C5.98535 37.05 7.00534 36 8.29534 36H87.7054C88.9654 36 90.0154 37.02 90.0154 38.31V45.72C89.9854 47.01 88.9654 48.03 87.7054 48.03Z"
      fill="url(#paint52_linear_13_431)"
    />
    <path
      d="M87.7054 48.03H8.29534C7.03534 48.03 5.98535 47.01 5.98535 45.72V38.31C5.98535 37.05 7.00534 36 8.29534 36H87.7054C88.9654 36 90.0154 37.02 90.0154 38.31V45.72C89.9854 47.01 88.9654 48.03 87.7054 48.03Z"
      fill="url(#paint53_linear_13_431)"
    />
    <path
      d="M87.7054 48.03H8.29534C7.03534 48.03 5.98535 47.01 5.98535 45.72V38.31C5.98535 37.05 7.00534 36 8.29534 36H87.7054C88.9654 36 90.0154 37.02 90.0154 38.31V45.72C89.9854 47.01 88.9654 48.03 87.7054 48.03Z"
      fill="url(#paint54_linear_13_431)"
    />
    <path
      d="M87.7054 48.03H8.29534C7.03534 48.03 5.98535 47.01 5.98535 45.72V38.31C5.98535 37.05 7.00534 36 8.29534 36H87.7054C88.9654 36 90.0154 37.02 90.0154 38.31V45.72C89.9854 47.01 88.9654 48.03 87.7054 48.03Z"
      fill="url(#paint55_linear_13_431)"
    />
    <path
      d="M87.7054 48.03H8.29534C7.03534 48.03 5.98535 47.01 5.98535 45.72V38.31C5.98535 37.05 7.00534 36 8.29534 36H87.7054C88.9654 36 90.0154 37.02 90.0154 38.31V45.72C89.9854 47.01 88.9654 48.03 87.7054 48.03Z"
      fill="url(#paint56_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint57_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint58_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint59_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint60_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint61_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint62_linear_13_431)"
    />
    <rect
      x="17.907"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint63_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint64_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint65_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint66_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint67_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint68_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint69_linear_13_431)"
    />
    <rect
      x="30.0117"
      y="56.9623"
      width="9.05147"
      height="23.9217"
      rx="0.35"
      fill="url(#paint70_linear_13_431)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.7661 37.0974) rotate(180) scale(3.71276 11.9489)"
      >
        <stop stop-color="#7A5E81" />
        <stop
          offset="1"
          stop-color="#281D26"
        />
      </radialGradient>
      <radialGradient
        id="paint1_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.4561 37.0974) rotate(180) scale(1.9708 6.47752)"
      >
        <stop stop-color="#836488" />
        <stop
          offset="1"
          stop-color="#836488"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(65.7661 37.0974) rotate(180) scale(3.71276 11.9489)"
      >
        <stop stop-color="#7A5E81" />
        <stop
          offset="1"
          stop-color="#281D26"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.4561 37.0974) rotate(180) scale(1.9708 6.47752)"
      >
        <stop stop-color="#836488" />
        <stop
          offset="1"
          stop-color="#836488"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint4_linear_13_431"
        x1="28.6925"
        y1="24.2918"
        x2="73.6619"
        y2="24.2918"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A59EAA" />
        <stop
          offset="1"
          stop-color="#BDB5C2"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_13_431"
        x1="44.7197"
        y1="32.0483"
        x2="44.6327"
        y2="7.57431"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0396643"
          stop-color="#846C7C"
        />
        <stop
          offset="0.14472"
          stop-color="#ADA5B2"
        />
        <stop
          offset="0.223903"
          stop-color="#AEA6B3"
          stop-opacity="0"
        />
        <stop
          offset="0.840316"
          stop-color="#BBB3C0"
          stop-opacity="0"
        />
        <stop
          offset="0.901222"
          stop-color="#B7AFBC"
        />
        <stop
          offset="0.962649"
          stop-color="#BDB5C2"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_13_431"
        x1="19.2824"
        y1="19.515"
        x2="76.4893"
        y2="19.515"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0199671"
          stop-color="#846C7C"
        />
        <stop
          offset="0.0659072"
          stop-color="#A199A7"
        />
        <stop
          offset="0.10544"
          stop-color="#AEA6B3"
          stop-opacity="0"
        />
        <stop
          offset="0.882694"
          stop-color="#BBB3C0"
          stop-opacity="0"
        />
        <stop
          offset="0.938478"
          stop-color="#B7AFBC"
        />
        <stop
          offset="0.971645"
          stop-color="#D2CCD5"
        />
      </linearGradient>
      <radialGradient
        id="paint7_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.7142 29.0454) rotate(131.629) scale(3.44177 7.14022)"
      >
        <stop stop-color="#948292" />
        <stop
          offset="0.381655"
          stop-color="#978695"
          stop-opacity="0.61"
        />
        <stop
          offset="0.998642"
          stop-color="#A8A1AD"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint8_linear_13_431"
        x1="32.4933"
        y1="12.0198"
        x2="32.4933"
        y2="27.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D235A" />
        <stop
          offset="1"
          stop-color="#222058"
        />
      </linearGradient>
      <radialGradient
        id="paint9_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.307 17.0223) rotate(70.3197) scale(7.74627 10.1469)"
      >
        <stop
          offset="0.19781"
          stop-color="#19171A"
        />
        <stop
          offset="0.259293"
          stop-color="#3F2245"
          stop-opacity="0"
        />
        <stop
          offset="0.471999"
          stop-color="#643566"
          stop-opacity="0.93"
        />
        <stop
          offset="0.780916"
          stop-color="#422255"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint10_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.2588 16.654) rotate(154.662) scale(3.13092 3.05782)"
      >
        <stop
          offset="0.277712"
          stop-color="#201A28"
        />
        <stop
          offset="0.569781"
          stop-color="#321F45"
          stop-opacity="0.85"
        />
        <stop
          offset="0.907282"
          stop-color="#3B2253"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint11_linear_13_431"
        x1="34.7561"
        y1="29.5643"
        x2="34.7676"
        y2="23.315"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.431099"
          stop-color="#0A0220"
          stop-opacity="0.88"
        />
        <stop
          offset="0.564131"
          stop-color="#32235A"
          stop-opacity="0.4"
        />
        <stop
          offset="0.723458"
          stop-color="#F0EFFF"
          stop-opacity="0.1"
        />
        <stop
          offset="0.949513"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint12_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.5398 14.4718) rotate(167.969) scale(2.54951 5.35142)"
      >
        <stop stop-color="#36223C" />
        <stop
          offset="1"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint13_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.4505 25.275) rotate(163.717) scale(3.03927 6.37945)"
      >
        <stop stop-color="#29223E" />
        <stop
          offset="0.773637"
          stop-color="#32223E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint14_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.9948 25.4197) rotate(-179.86) scale(4.4873 9.41887)"
      >
        <stop
          offset="0.122721"
          stop-color="#1C0C4B"
        />
        <stop
          offset="0.471999"
          stop-color="#32223E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint15_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.9886 20.9842) rotate(-119.04) scale(3.04979 6.95677)"
      >
        <stop stop-color="#3A2259" />
        <stop
          offset="0.204627"
          stop-color="#3A2259"
        />
        <stop
          offset="1"
          stop-color="#3B2253"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint16_linear_13_431"
        x1="44.9835"
        y1="12.03"
        x2="44.9835"
        y2="27.054"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D235A" />
        <stop
          offset="1"
          stop-color="#222058"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_13_431"
        x1="40.6059"
        y1="14.717"
        x2="47.3555"
        y2="19.1075"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.216941"
          stop-color="#452259"
          stop-opacity="0"
        />
        <stop
          offset="0.52515"
          stop-color="#FFFFFF"
          stop-opacity="0.1"
        />
        <stop
          offset="1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_13_431"
        x1="47.4657"
        y1="27.3986"
        x2="47.4657"
        y2="18.0508"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#32235A"
          stop-opacity="0"
        />
        <stop
          offset="0.366408"
          stop-color="#32235A"
          stop-opacity="0"
        />
        <stop
          offset="0.517857"
          stop-color="#F0EFFF"
          stop-opacity="0.12"
        />
        <stop
          offset="0.949513"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint19_linear_13_431"
        x1="39.952"
        y1="19.0019"
        x2="48.9087"
        y2="18.9483"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.509322"
          stop-color="#32235A"
          stop-opacity="0"
        />
        <stop
          offset="0.73668"
          stop-color="#7886FF"
          stop-opacity="0.1"
        />
        <stop
          offset="0.898781"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint20_linear_13_431"
        x1="40.6059"
        y1="14.717"
        x2="47.3555"
        y2="19.1075"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.334698"
          stop-color="#3B224A"
        />
        <stop
          offset="0.470822"
          stop-color="#462459"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint21_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(46.8289 12.03) rotate(-69.4852) scale(3.64057 8.19374)"
      >
        <stop stop-color="#432347" />
        <stop
          offset="0.74792"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint22_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.7948 25.9448) rotate(114.779) scale(4.25091 13.7456)"
      >
        <stop stop-color="#1A132D" />
        <stop
          offset="0.520164"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint23_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.3807 22.8053) rotate(174.958) scale(5.15588 9.09549)"
      >
        <stop
          offset="0.0929266"
          stop-color="#221632"
        />
        <stop
          offset="0.826345"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint24_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(50.6786 23.3998) rotate(47.0825) scale(4.96205 8.75356)"
      >
        <stop
          offset="0.0771635"
          stop-color="#221632"
        />
        <stop
          offset="0.403697"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint25_linear_13_431"
        x1="62.9825"
        y1="12.03"
        x2="62.9825"
        y2="27.0503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D235A" />
        <stop
          offset="1"
          stop-color="#222058"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_13_431"
        x1="62.9854"
        y1="17.2479"
        x2="62.9854"
        y2="21.7425"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.128532"
          stop-color="#452259"
          stop-opacity="0"
        />
        <stop
          offset="0.52515"
          stop-color="#FFFFFF"
          stop-opacity="0.1"
        />
        <stop
          offset="1"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint27_linear_13_431"
        x1="56.3457"
        y1="17.0602"
        x2="69.4146"
        y2="17.0911"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0348136"
          stop-color="#0E0B10"
        />
        <stop
          offset="0.169658"
          stop-color="#4C2B60"
          stop-opacity="0.59"
        />
        <stop
          offset="0.790425"
          stop-color="#312245"
          stop-opacity="0"
        />
        <stop
          offset="0.974698"
          stop-color="#36245B"
        />
      </linearGradient>
      <linearGradient
        id="paint28_linear_13_431"
        x1="62.9854"
        y1="12.9165"
        x2="62.9825"
        y2="27.0503"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.404558"
          stop-color="#452258"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#08055B"
        />
      </linearGradient>
      <linearGradient
        id="paint29_linear_13_431"
        x1="56.3457"
        y1="17.0602"
        x2="69.4146"
        y2="17.0911"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0808964"
          stop-color="#3F2853"
          stop-opacity="0"
        />
        <stop
          offset="0.161424"
          stop-color="#FFFFFF"
          stop-opacity="0.13"
        />
        <stop
          offset="0.316154"
          stop-color="#48225A"
          stop-opacity="0"
        />
        <stop
          offset="0.729975"
          stop-color="#48225A"
          stop-opacity="0"
        />
        <stop
          offset="0.863759"
          stop-color="#FFFFFF"
          stop-opacity="0.13"
        />
        <stop
          offset="0.95034"
          stop-color="#46235A"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint30_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.7484 12.8685) rotate(47.1211) scale(1.79647 4.67738)"
      >
        <stop
          offset="0.0929266"
          stop-color="#412345"
        />
        <stop
          offset="1"
          stop-color="#5B255B"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint31_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.2002 13.2058) rotate(50.371) scale(2.09486 5.45429)"
      >
        <stop
          offset="0.0929266"
          stop-color="#412345"
        />
        <stop
          offset="1"
          stop-color="#5B255B"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint32_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.7964 26.5499) rotate(30.6) scale(4.46709 4.24335)"
      >
        <stop
          offset="0.0929266"
          stop-color="#1A132D"
        />
        <stop
          offset="0.74792"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint33_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(58.3514 26.4849) rotate(128.264) scale(2.61739 5.5825)"
      >
        <stop
          offset="0.0929266"
          stop-color="#1A132D"
        />
        <stop
          offset="0.74792"
          stop-color="#312652"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint34_linear_13_431"
        x1="8.98535"
        y1="72.1532"
        x2="86.9853"
        y2="72.1532"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A59CA9" />
        <stop
          offset="1"
          stop-color="#BFB4C5"
        />
      </linearGradient>
      <linearGradient
        id="paint35_linear_13_431"
        x1="8.17194"
        y1="61.5833"
        x2="16.7869"
        y2="61.6245"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6E616E" />
        <stop
          offset="0.296347"
          stop-color="#6E616E"
          stop-opacity="0"
        />
        <stop
          offset="0.632218"
          stop-color="#9E93A1"
          stop-opacity="0"
        />
        <stop
          offset="0.788421"
          stop-color="#5B535B"
        />
        <stop
          offset="0.88007"
          stop-color="#6E616E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint36_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.23 51.185) rotate(149.39) scale(8.12369 14.2492)"
      >
        <stop
          offset="0.276917"
          stop-color="#A298A6"
        />
        <stop
          offset="0.562762"
          stop-color="#A298A6"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint37_linear_13_431"
        x1="15.3778"
        y1="47.6844"
        x2="15.3778"
        y2="49.6063"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6E616E" />
        <stop
          offset="1"
          stop-color="#6E616E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint38_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-2.97881 35.0282) rotate(39.1304) scale(42.7833 57.0584)"
      >
        <stop stop-color="#887B8B" />
        <stop
          offset="1"
          stop-color="#887B8B"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint39_linear_13_431"
        x1="87.1924"
        y1="64.6514"
        x2="84.7787"
        y2="64.6514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E0DCE2" />
        <stop
          offset="1"
          stop-color="#E0DCE2"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint40_linear_13_431"
        x1="28.4899"
        y1="84.0345"
        x2="28.4854"
        y2="53.2315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#323870" />
        <stop
          offset="0.92529"
          stop-color="#5C275C"
        />
        <stop
          offset="0.985547"
          stop-color="#2A192E"
        />
      </linearGradient>
      <linearGradient
        id="paint41_linear_13_431"
        x1="44.4075"
        y1="56.2621"
        x2="18.254"
        y2="56.1794"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0668338"
          stop-color="#443268"
          stop-opacity="0"
        />
        <stop
          offset="0.126919"
          stop-color="#F7EFFC"
          stop-opacity="0.03"
        />
        <stop
          offset="0.172078"
          stop-color="#483067"
          stop-opacity="0.26"
        />
        <stop
          offset="1"
          stop-color="#4A2F65"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint42_linear_13_431"
        x1="28.4854"
        y1="50.3971"
        x2="28.4854"
        y2="84.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0843437"
          stop-color="#443268"
          stop-opacity="0"
        />
        <stop
          offset="0.116721"
          stop-color="#F7EFFC"
          stop-opacity="0.05"
        />
        <stop
          offset="0.169187"
          stop-color="#483067"
          stop-opacity="0.26"
        />
        <stop
          offset="1"
          stop-color="#4A2F65"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint43_linear_13_431"
        x1="13.7616"
        y1="60.7129"
        x2="28.4854"
        y2="60.6298"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0209928"
          stop-color="#140A1C"
        />
        <stop
          offset="0.252918"
          stop-color="#3A346B"
          stop-opacity="0"
        />
        <stop
          offset="0.648368"
          stop-color="#572A5F"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#542B61"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint44_linear_13_431"
        x1="28.4854"
        y1="85.0764"
        x2="28.4854"
        y2="79.2285"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.163805"
          stop-color="#282953"
        />
        <stop
          offset="0.430175"
          stop-color="#37376E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint45_radial_13_431"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(41.3236 54.4845) rotate(126.655) scale(3.24127 6.70333)"
      >
        <stop
          offset="0.373674"
          stop-color="#44224B"
          stop-opacity="0.61"
        />
        <stop
          offset="0.831086"
          stop-color="#572C5A"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint46_linear_13_431"
        x1="50.505"
        y1="66.015"
        x2="53.2172"
        y2="66.015"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop
          offset="1"
          stop-color="#5DFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint47_linear_13_431"
        x1="58.845"
        y1="72.6978"
        x2="58.845"
        y2="70.189"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop
          offset="1"
          stop-color="#5DFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint48_linear_13_431"
        x1="66.0069"
        y1="69.6151"
        x2="66.0059"
        y2="77.5159"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FAFAFA"
          stop-opacity="0"
        />
        <stop
          offset="0.161013"
          stop-color="#80FFFF"
          stop-opacity="0.2"
        />
        <stop
          offset="0.485489"
          stop-color="#80FFFF"
        />
      </linearGradient>
      <linearGradient
        id="paint49_linear_13_431"
        x1="58.6418"
        y1="66.6086"
        x2="42.2398"
        y2="66.4579"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.139675"
          stop-color="#51D3F8"
          stop-opacity="0"
        />
        <stop
          offset="0.397796"
          stop-color="#5CF2FE"
        />
      </linearGradient>
      <linearGradient
        id="paint50_linear_13_431"
        x1="86.0698"
        y1="64.0378"
        x2="66.2163"
        y2="64.0378"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.390645"
          stop-color="#1E8DDC"
          stop-opacity="0.87"
        />
        <stop
          offset="0.513892"
          stop-color="#41B8FB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint51_linear_13_431"
        x1="64.5004"
        y1="57.7999"
        x2="64.5003"
        y2="64.2283"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.246812"
          stop-color="#168AEA"
        />
        <stop
          offset="0.613782"
          stop-color="#40ADF0"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint52_linear_13_431"
        x1="19.8962"
        y1="48.03"
        x2="81.0212"
        y2="48.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EF3D89" />
        <stop
          offset="1"
          stop-color="#FF3D51"
        />
      </linearGradient>
      <linearGradient
        id="paint53_linear_13_431"
        x1="48.0004"
        y1="49.5626"
        x2="48.0004"
        y2="32.7023"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0543229"
          stop-color="#B43A5F"
        />
        <stop
          offset="0.319327"
          stop-color="#FA3E5D"
          stop-opacity="0"
        />
        <stop
          offset="0.631688"
          stop-color="#FF3D51"
          stop-opacity="0"
        />
        <stop
          offset="0.977955"
          stop-color="#C53B65"
        />
      </linearGradient>
      <linearGradient
        id="paint54_linear_13_431"
        x1="90.0154"
        y1="43.7489"
        x2="86.0361"
        y2="43.7489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5766" />
        <stop
          offset="1"
          stop-color="#FF5766"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint55_linear_13_431"
        x1="4.34089"
        y1="43.6936"
        x2="9.70463"
        y2="43.6936"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.210064"
          stop-color="#7C274B"
          stop-opacity="0.87"
        />
        <stop
          offset="0.893484"
          stop-color="#EC3E88"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint56_linear_13_431"
        x1="92.7473"
        y1="43.5993"
        x2="84.6415"
        y2="43.523"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.191511"
          stop-color="#BC3C4A"
        />
        <stop
          offset="0.599467"
          stop-color="#FF4C5D"
          stop-opacity="0.06"
        />
        <stop
          offset="0.807847"
          stop-color="#FF4054"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint57_linear_13_431"
        x1="22.4327"
        y1="56.9623"
        x2="22.4327"
        y2="80.8839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4DC7FF" />
        <stop
          offset="1"
          stop-color="#62F1FF"
        />
      </linearGradient>
      <linearGradient
        id="paint58_linear_13_431"
        x1="17.7461"
        y1="68.9231"
        x2="19.1291"
        y2="68.9231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop
          offset="1"
          stop-color="#5DFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint59_linear_13_431"
        x1="20.5389"
        y1="82.2118"
        x2="20.5389"
        y2="77.2231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop
          offset="1"
          stop-color="#5DFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint60_linear_13_431"
        x1="22.9372"
        y1="76.0819"
        x2="22.9256"
        y2="91.7926"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FAFAFA"
          stop-opacity="0"
        />
        <stop
          offset="0.161013"
          stop-color="#80FFFF"
          stop-opacity="0.2"
        />
        <stop
          offset="0.485489"
          stop-color="#80FFFF"
        />
      </linearGradient>
      <linearGradient
        id="paint61_linear_13_431"
        x1="20.4709"
        y1="70.1035"
        x2="14.9779"
        y2="70.095"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.139675"
          stop-color="#51D3F8"
          stop-opacity="0"
        />
        <stop
          offset="0.555333"
          stop-color="#5CF2FE"
        />
      </linearGradient>
      <linearGradient
        id="paint62_linear_13_431"
        x1="30.2211"
        y1="65.0752"
        x2="23.0074"
        y2="64.9915"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.460792"
          stop-color="#1E8DDC"
          stop-opacity="0.87"
        />
        <stop
          offset="0.751135"
          stop-color="#41B8FB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint63_linear_13_431"
        x1="22.4327"
        y1="52.5873"
        x2="22.4326"
        y2="65.3703"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.367086"
          stop-color="#168AEA"
        />
        <stop
          offset="0.512997"
          stop-color="#40ADF0"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint64_linear_13_431"
        x1="34.5375"
        y1="56.9623"
        x2="34.5375"
        y2="80.8839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4DC7FF" />
        <stop
          offset="1"
          stop-color="#62F1FF"
        />
      </linearGradient>
      <linearGradient
        id="paint65_linear_13_431"
        x1="29.8509"
        y1="68.9231"
        x2="31.2338"
        y2="68.9231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop
          offset="1"
          stop-color="#5DFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint66_linear_13_431"
        x1="32.6437"
        y1="82.2118"
        x2="32.6437"
        y2="77.2231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop
          offset="1"
          stop-color="#5DFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint67_linear_13_431"
        x1="35.0419"
        y1="76.0819"
        x2="35.0303"
        y2="91.7926"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#FAFAFA"
          stop-opacity="0"
        />
        <stop
          offset="0.161013"
          stop-color="#80FFFF"
          stop-opacity="0.2"
        />
        <stop
          offset="0.485489"
          stop-color="#80FFFF"
        />
      </linearGradient>
      <linearGradient
        id="paint68_linear_13_431"
        x1="32.5756"
        y1="70.1035"
        x2="27.0827"
        y2="70.095"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.139675"
          stop-color="#51D3F8"
          stop-opacity="0"
        />
        <stop
          offset="0.555333"
          stop-color="#5CF2FE"
        />
      </linearGradient>
      <linearGradient
        id="paint69_linear_13_431"
        x1="42.3258"
        y1="65.0752"
        x2="35.1121"
        y2="64.9915"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.460792"
          stop-color="#1E8DDC"
          stop-opacity="0.87"
        />
        <stop
          offset="0.751135"
          stop-color="#41B8FB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint70_linear_13_431"
        x1="34.5375"
        y1="52.5873"
        x2="34.5373"
        y2="65.3703"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.367086"
          stop-color="#168AEA"
        />
        <stop
          offset="0.512997"
          stop-color="#40ADF0"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
